module.exports = __webpack_public_path__ + "static/forecast/temperature/very-cold-0a98026a10fb94e3b32b458eb8b7b20e.svg";